import {getModuleDetailApi, getLastVersionApi, checkExtendUrlApi} from "@/RoseRepo.js"

	import i18n from './i18n/index.js';
	import linkImg from 'assets/images/extenedUrl/icon.png';
	import logoImg from 'assets/images/extenedUrl/logo.png';
	import bgImg from 'assets/images/extenedUrl/bg.png';
async function GetExtenedUrl(path)
{
            let params = path.split('/').filter((ele) => ele !== '');
            const moduleFullName = params[0];
            const moduleType = moduleFullName.split('-')[0];
            const moduleAuthor = moduleFullName.split('-')[1];
            const moduleName = moduleFullName.split('-')[2];
            const result = await checkExtendUrlApi({
                moduleName: moduleFullName,
                url: process.realm.REALM_APP_REMOTE + path
            })
            if (result.code === 0 && !result.data)
            {
                const data = {
                    title: 'Error',
                    msg: i18n.global.t('extenedUrl.invalidUrl'),
                };
                RenderTemplate(data);
                return
            }
            const res = checkAuth() ? await getModuleDetailApi({ moduleName: moduleFullName }) : await getLastVersionApi({ moduleName: moduleFullName });
            let url = '';
            if (res?.moduleVersionId)
            {
                const { version } = res;
                url = `/${moduleAuthor}/${moduleType == 'app' ? '' : (moduleType + '/')}${moduleName}.sys/${version}/`;
                let jumpData = {
                    moduleName: moduleFullName,
                    _self: '_self',
                    type: 'openApplication',
                    autoInstall: true,
                    data: {
                        appModuleName: moduleFullName
                    }
                }
                switch (moduleFullName)
                {
                    case 'app-honourbell-meeting':
                        jumpData.data = {
                            appModuleName: moduleFullName,
                            meetingCode: params[2],
                            sitter: false,
                            useErrorTips: true
                        }
                        break;
                    case 'app-honourbell-spitfire':
                        jumpData.data = {
                            appModuleName: moduleFullName,
                            url: path.split('toUrl/')[1]
                        }
                        break;
                    default:
                        jumpData.data.path = params.splice(1).join('/');
                        break;
                }
                if (!checkAuth())
                {
                    return `/${moduleAuthor}/${moduleType==='app'?'':(moduleType+'/')}${moduleName}.sys/${version}/landing.html`
                }
                window.top.Empower.utils.crossPageInteraction.jump(jumpData)
            }
            return url;
}
function ExtenedUrlTemplate(data)
{
    	const { msg, title } = data;
    	const domStr = `
    	    <div class="extenedurl-header">
    	        <img src=${logoImg} />
    	        Codigger - Extended URL
    	    </div>
    	    <div class="extenedurl-body">
    	        <div class="extenedurl-error-wrapper">
    	            <img src=${linkImg} width="144" height="144" />
    	            <div>
    	                <div class="extenedurl-error-title">${i18n.global.t('extenedUrl.error')}</div>
    	                <div class="extenedurl-error-desc">${msg}</div>
    	            </div>
    	        </div>
    	        <div class="extenedurl-btn-wrapper">
    	            <a class="extenedurl-error-btn" href="/web/portal">
    	                ${i18n.global.t('extenedUrl.toDesktop')}
    	            </a>
    	        </div>
    	    </div>
    	    <div class="extenedurl-footer">Copyright Ⓒ 2025 Codigger. All Rights Reserved.</div>
    	`
    	const dom = document.createElement('div');
    	dom.classList.add('extenedurl-wrapper');
    	dom.innerHTML = domStr;
    	return dom
}
function ExtendUrlStyle()
{
    	const styleContent = `
            .extenedurl-btn-wrapper {
                display: flex;
                align-items: center;
                gap: 16px;
            }
            .extenedurl-learn-btn {
                text-decoration: none;
                color: #FF8000;
            }
            .extenedurl-error-btn {
                padding: 0 20px;
                height: 40px;
                border-radius: 20px;
                background: linear-gradient(0deg, #FF8000 0%, #F84D00 100%);
                box-sizing: border-box;
                border: 1px solid rgba(255, 255, 255, 0.2758);
                line-height: 40px;
                cursor: pointer;
                font-size: 16px;
                font-weight: normal;
                text-decoration: none;
                color: #fff;
            }
            .extenedurl-error-title {
                font-size: 36px;
                font-weight: normal;
                line-height: 80px;
            }
            .extenedurl-error-desc {
                font-size: 18px;
                font-weight: normal;
                color: rgba(255, 255, 255, 0.6);
            }
            .extenedurl-error-wrapper {
                display: flex;
                gap: 16px;
            }
            .extenedurl-body {
                display: flex;
                align-items: center;
                flex-direction: column;
                margin-top: 150px;
                gap: 50px;
            }
            .extenedurl-wrapper {
                background: url(${bgImg});
                background-size: 100% 100%;
                height: 100vh;
                background-repeat: no-repeat;
                padding: 20px;
                color: #FFFFFF;
                display: grid;
                grid-template-rows: max-content 1fr 80px;
            }
            .extenedurl-header {
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: normal;
                gap: 10px;
            }
            .extenedurl-footer {
                text-align: center;
                font-size: 12px;
                font-weight: normal;
                color: rgba(255, 255, 255, 0.4002);
            }
        `
    	const dom = document.createElement('style');
    	dom.innerHTML = styleContent
    	return dom
}
function RenderTemplate(data)
{
    	document.body.append(ExtenedUrlTemplate(data), ExtendUrlStyle());
    	return;
}
async function HandleExtenedUrl(path)
{
        if (/([a-zA-Z0-9]{2,40}-){2,5}([a-zA-Z0-9]+)\/*$/.test(path))
        {
            return await GetLandingPageUrl(path);
        }
        if (/(^\/([a-zA-Z0-9]{2,40}-){2,5}([a-zA-Z0-9]+))(\/[a-zA-Z0-9#\/\?=.:'"]+)$/.test(path))
        {
            return await GetExtenedUrl(path);
        }
        if (/(^\/([a-zA-Z0-9]+))\/([a-zA-Z0-9-]+)(\/){0,1}$/.test(path))
        {
            return await GetStandaloneUrl(path);
        }
        let params = path.split('/').filter((ele) => ele !== '');
        if (params.length < 2)
        {
            const data = {
                title: 'Error',
                msg: i18n.global.t('extenedUrl.invalidUrl'),
            };
            RenderTemplate(data);
        }
}
async function GetLandingPageUrl(url)
{
        const params = url.split('/');
        const modulePathname = url.split(/\?|\#/)[0];
        const islegalLen = params.length == 2 || (params.length == 3 && params[2] === '');
        const islegalModulePathName = /([a-zA-Z0-9]{2,40}-){2,5}([a-zA-Z0-9\/])+$/.test(modulePathname);
        if(islegalLen && islegalModulePathName)
        {
            const result = await getLastVersionApi({ moduleName: params[1] })
            if (result)
            {
                const { moduleName, version } = result;
                const moduleInfoArr = moduleName.split('-')
                const moduleType = moduleInfoArr[0] === 'app' ? '' : moduleInfoArr[0] + '/';
                const author = moduleInfoArr[1];
                const moduleShortName = moduleInfoArr.splice(2).join('-');
                return `/${author}/${moduleType}${moduleShortName}.sys/${version}/landing.html`
            }
            return `/web/portal.sys/module${modulePathname}`;
        }
}
async function GetStandaloneUrl(url)
{
            const params = url.split('/').filter((ele) => ele !== '');
            const moduleName =`app-${params[0]}-${params[1]}`
            const result = await getModuleDetailApi({ moduleName })
            console.log(result)
            if (result)
            {
                const { version } = result;
                return `/${params[0]}/${params[1]}.sys/${version}/`
            }
            const data = {
                title: 'Error',
                msg: i18n.global.t('extenedUrl.invalidUrl'),
            };
            RenderTemplate(data);
}
    const checkAuth = () =>
    {
        const token = localStorage.getItem('oauth-token');
        return Boolean(token);
    }
	export const handleExtenedUrl = async (path) => HandleExtenedUrl(path);

